import { motion } from "framer-motion";
import { ShieldCheck, Clock, Sparkles } from "lucide-react";
import { BookingWidget } from "../booking/BookingWidget";

const HERO_IMG =
  "https://static.prod-images.emergentagent.com/jobs/50440326-f793-45b3-85c9-b419cf332040/images/ac502e3999a1bfbef2b3df174680979da1b530c8cb57628e9f9ae718e8c6ab31.jpeg";

const TRUST = [
  { icon: Clock, label: "10+ Years Experience" },
  { icon: Sparkles, label: "Fleet Under 3 Years" },
  { icon: ShieldCheck, label: "Fixed Prices from £99" },
];

const fade = (delay = 0) => ({
  initial: { opacity: 0, y: 24 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 1, delay, ease: [0.22, 1, 0.36, 1] },
});

export const Hero = () => {
  return (
    <section id="top" className="relative min-h-screen w-full overflow-hidden" data-testid="hero-section">
      <div className="absolute inset-0">
        <img
          src={HERO_IMG}
          alt="Upper Class Chauffeurs Mercedes S-Class at night in London"
          className="h-full w-full object-cover object-[62%_center] md:object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/70 to-ink/40" />
        <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/60 to-transparent md:to-ink/10" />
      </div>

      <div className="relative z-10 mx-auto grid min-h-screen max-w-7xl grid-cols-1 items-center gap-8 px-6 pb-14 pt-24 sm:gap-10 sm:pb-16 lg:grid-cols-2 lg:gap-16 lg:px-10 lg:pt-32">
        <div className="order-2 text-left lg:order-1">
          <motion.span
            {...fade(0.1)}
            className="mb-6 inline-flex items-center gap-3 text-[0.7rem] uppercase tracking-[0.35em] text-gold"
          >
            <span className="h-px w-10 bg-gold/60" />
            London · Private Chauffeur Service
          </motion.span>

          <motion.h1
            {...fade(0.25)}
            className="max-w-xl font-heading text-4xl font-light leading-[1.02] tracking-tight text-white sm:text-5xl lg:text-6xl"
          >
            Arrive in a <span className="italic text-gold">class</span> of your own
          </motion.h1>

          <motion.p {...fade(0.4)} className="mt-6 max-w-md text-sm leading-relaxed text-white/70 md:text-base">
            Chauffeur-driven Mercedes and Range Rover across London and beyond. Get an instant fixed price and reserve
            your journey in seconds.
          </motion.p>

          <motion.div {...fade(0.55)} className="mt-9 flex flex-wrap gap-x-6 gap-y-3">
            {TRUST.map(({ icon: Icon, label }) => (
              <span key={label} className="flex items-center gap-2 text-xs uppercase tracking-widest text-white/60">
                <Icon size={15} className="text-gold" />
                {label}
              </span>
            ))}
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30, scale: 0.98 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          transition={{ duration: 1, delay: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="order-1 flex justify-center lg:order-2 lg:justify-end"
        >
          <BookingWidget />
        </motion.div>
      </div>
    </section>
  );
};
